define(function (require) {
  const $ = require("jquery");
  var CommonView = require("site/common/view");
  var config = require("common/page-config");

  return CommonView.extend({
    templateId: "basket-summary-widget-header-template",

    initialize (options) {
      this.options = options || {};
      this.$el = this.options.el || $("#widget-header");
      if (config.isWidget) {
        this.render();
      }
    },

    render () {
      var venue = this.getVenueForType(this.options.type);

      if (config.isWidget && venue) {
        this.renderTemplate({
          venue: this.getVenueMustacheModel(venue)
        });
      }
    },

    getVenueFromData (data, parentKey) {
      if (!data) {
        return {};
      }
      var parent = data[parentKey][0];

      if (!parent.venues || parent.venues.length === 0) {
        return {};
      }

      var venue = parent.venues[0];

      venue.chain = parent.chain || venue.chain;
      return venue;
    },

    getVenueForType () {
      switch (this.options.type) {
      case "checkout":
        return this.getVenueFromData(this.options.data, "offers");
      case "cancel":
        return this.getVenueFromData(config.order, "itemGroups");
      default:
        return config.venue;
      }
    },

    getVenueMustacheModel (venue) {
      var lines = [];

      if (!venue.address) {
        return {
          name: venue.name
        };
      }
      if (!venue.address.lines) {
        lines = Object.keys(venue.address).filter(function (key) {
          return key.indexOf("line") !== -1;
        }).map(function (key) {
          return venue.address[key];
        });
      } else {
        lines = venue.address.lines.slice();
      }
      var chain = venue.chain ? venue.chain.displayName : null;
      var address = this.formatAddressInline(lines, venue.address.postalRef, config.channel);

      if (chain) {
        address = address + ". ";
      }

      return {
        name: venue.name,
        address: address,
        chain: chain
      };
    },
    // copied from front-end-2.0/src/js/helpers/formatters.js
    formatAddressInline (address, postalCode, channelCode) {
      var NEW_LINE_CHANNEL_CODES = [
        "WHN_GB", "WHN_IE",
        "WDG_GB", "WDG_IE"
      ];

      if (!address) {
        return null;
      }

      var isNewLinePostCode = NEW_LINE_CHANNEL_CODES.indexOf(channelCode) > -1;
      var postCode = postalCode || "";
      var isNewLine = isNewLinePostCode || address.length === 1;
      var lastLine = address[address.length - 1];
      var finalAddress = address.slice(0, address.length - 1);

      if (!isNewLine) {
        finalAddress.push(`${postCode} ${lastLine}`);
      } else {
        finalAddress.push(lastLine);
        if (postCode && channelCode !== "WDG_IE") {
          finalAddress.push(postCode);
        }
      }
      return finalAddress.join(", ");
    }
  });
});
